/**
 * ForbiddenPage — Página 403 para acceso denegado
 * Exporta: ForbiddenPage (named + default)
 * Invoca: ErrorPage (@/pages/error/ErrorPage)
 * NO debe contener lógica de negocio.
 * Se muestra cuando el usuario no tiene permisos para acceder a un recurso.
 */

import { ArrowLeft, ShieldOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ErrorPage } from "./ErrorPage";

export const ForbiddenPage = () => {
  const navigate = useNavigate();

  return (
    <ErrorPage
      code="403"
      title="Acceso denegado"
      description="No tienes permisos para acceder a esta sección. Si crees que es un error, contacta al administrador de tu negocio."
      icon={<ShieldOff className="w-12 h-12 text-amber-500" />}
      accentColor="text-amber-600 dark:text-amber-400"
      actions={[
        {
          label: "Volver al Dashboard",
          icon: <ArrowLeft size={18} />,
          onClick: () => navigate("/dashboard"),
          variant: "outline" as const,
        },
      ]}
    />
  );
};

export default ForbiddenPage;
